import styled from "styled-components/macro";
import React from "react";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
`;

const Inner = styled.div`
  padding: 16px;
  background: #f4f4f4;
  border-radius: 8px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
const TextTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 16px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;

const Text = styled.div`
  margin-bottom: 16px;
`;

export const StudentAcceptRequestMessage: React.FC<{ t: Function }> = React.memo(({ t }) => {
  return (
    <Root>
      <Inner>
        <TextTitle>{t("systemMessages.studentAcceptRequestMessage.pendingChatRequest")}</TextTitle>
        <Text>{t("systemMessages.studentAcceptRequestMessage.pendingInfo")}</Text>
      </Inner>
    </Root>
  );
});
